(function () {
  function initPdpGallery() {
    const root = document.querySelector('[data-pdp-gallery]');
    if (!root) return;
    
    // Перевіряємо, чи вже ініціалізовано
    if (root.hasAttribute('data-gallery-initialized')) return;
    root.setAttribute('data-gallery-initialized', 'true');

    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const prevBtn = root.querySelector('[data-prev]');
    const nextBtn = root.querySelector('[data-next]');

    if (thumbs.length === 0 || slides.length === 0) {
      console.warn('PDP Gallery: No thumbs or slides found');
      return;
    }

    const getActiveIndex = () => {
      return slides.findIndex(s => s.classList.contains('is-active'));
    };

    const setActiveById = (id) => {
      const idStr = String(id);
      slides.forEach(s => {
        const mediaId = String(s.dataset.mediaId || '');
        if (mediaId === idStr) {
          s.classList.add('is-active');
        } else {
          s.classList.remove('is-active');
        }
      });
      thumbs.forEach(t => {
        const targetId = String(t.dataset.targetId || '');
        if (targetId === idStr) {
          t.classList.add('is-active');
        } else {
          t.classList.remove('is-active');
        }
      });
    };

    const setActiveByIndex = (idx) => {
      const safe = (idx + slides.length) % slides.length;
      if (slides[safe] && slides[safe].dataset.mediaId) {
        setActiveById(slides[safe].dataset.mediaId);
        // Прокрутити активний thumb в зону видимості
        const activeThumb = thumbs.find(t => t.classList.contains('is-active'));
        if (activeThumb) {
          activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      }
    };

    const normalizeLabel = (value) => String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();

    const findMediaIdForVariant = (variant, selectedOptions) => {
      if (variant?.featured_media?.id) {
        return String(variant.featured_media.id);
      }

      const needles = [];
      if (variant?.title) needles.push(variant.title);
      (selectedOptions || []).forEach((option) => {
        if (option) needles.push(option);
      });

      if (needles.length === 0) return null;

      const match = slides.find((slide) => {
        const alt = normalizeLabel(slide.querySelector('img')?.alt);
        if (!alt) return false;
        return needles.some((needle) => {
          const normalizedNeedle = normalizeLabel(needle);
          return normalizedNeedle && (alt.includes(normalizedNeedle) || normalizedNeedle.includes(alt));
        });
      });

      return match?.dataset.mediaId || null;
    };

    const syncGalleryToVariant = (variant, selectedOptions) => {
      const mediaId = findMediaIdForVariant(variant, selectedOptions);
      if (mediaId) {
        setActiveById(mediaId);
      }
    };

    const productRoot = root.closest('.js-product');
    if (productRoot) {
      productRoot.addEventListener('on:variant:change', (evt) => {
        syncGalleryToVariant(evt.detail?.variant, evt.detail?.selectedOptions);
      });
    }

    // Додаємо обробники подій для мініатюр
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const targetId = thumb.dataset.targetId;
        if (targetId) {
          setActiveById(targetId);
        }
      }, false);
    });

    // Додаємо обробники подій для кнопок навігації
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        setActiveByIndex(getActiveIndex() - 1);
      }, false);
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        setActiveByIndex(getActiveIndex() + 1);
      }, false);
    }

  }

  // Ініціалізація при завантаженні DOM
  function runInit() {
    setTimeout(initPdpGallery, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  // Ініціалізація для theme editor
  document.addEventListener('shopify:section:load', function(event) {
    const root = event.target.querySelector('[data-pdp-gallery]');
    if (root) {
      root.removeAttribute('data-gallery-initialized');
    }
    setTimeout(initPdpGallery, 100);
  });
})();


